__turbopack_context__.v({
  "banner": "tih96W_banner",
  "icon": "tih96W_icon",
});
